"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const redux_1 = require("redux");
const service_1 = tslib_1.__importDefault(require("./service"));
const settingReducer_1 = tslib_1.__importDefault(require("./settingReducer"));
const reducers = redux_1.combineReducers({
    decoder: service_1.default,
    setting: settingReducer_1.default,
});
exports.default = reducers;
//# sourceMappingURL=index.js.map